import {
  useDeviceInfo,
  type DeviceInfo,
} from '~/composables/general/useDeviceInfo';
import FetchFactory from '../factory';

const CONTROLLER = '/api-electra/MobiltBankId/';

export type BankIdAuthResponse = {
  AutoStartToken: string;
  OrderReference: string;
  QrData: string;
  QrStartToken: string;
  Status: string;
};

export type BankIdCollectResponse = {
  Status: number;
  StatusDescription: string;
  Signature: string;
  QrData: string;
  HasClearedCartBecauseDifferentSsnAuthorized: boolean;
};

class MobiltBankIdModule extends FetchFactory<any> {
  //createReturnUrl = (device: DeviceInfo, testingType?: string) => {
  //  if (device.isChromeOnAppleDevice) {
  //    return encodeURIComponent('googlechrome://');
  //  }
  //  if (device.isFirefoxOnAppleDevice) {
  //    return encodeURIComponent('firefox://');
  //  }
  //  if (device.isOperaTouchOnAppleDevice) {
  //    return encodeURIComponent(
  //      `${window.location.href.replace('http', 'touch-http')}#initiated=true&testingType=${testingType}`,
  //    );
  //  }

  //  return encodeURIComponent(
  //    `${window.location.href}#initiated=true&testingType=${testingType}`,
  //  );
  //};

  // For documentation june 2025:
  // Replace this with a proper uuid package function if we start using returnUrl
  generateGUID = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  };

  // For documentation june 2025: This function can be used if we need to start
  // using the returnUrl parameter to have bankid return the user to the same
  // browser and tab after authentication. Right now we don't send a returnUrl,
  // which means the BankID app will either close after authentication and return
  // the user to the previous app (almost always the browser), or just leave BankID
  // running and the user has to navigate themselves.
  setNonceUrl = () => {
    const nonce = this.generateGUID();
    const { isFirefox, isChrome, isSafari } = useDeviceInfo();
    let protocol = window.location.origin;

    // For documentation june 2025:
    // Should help the device choose the correct browser to return to
    if (isFirefox) {
      protocol = 'firefox://';
    } else if (isChrome) {
      protocol = 'chrome://';
    } else if (isSafari) {
      protocol = 'x-safari-https://';
    }

    const newUrl = `${protocol}${window.location.pathname}#nonce=${nonce}`;

    // For documentation june 2025: Putting the nonce hash in the url
    // might help the device choose the correct tab to return to, not tested
    //history.replaceState(null, '', newUrl);

    // Send to bankid api
    return encodeURIComponent(newUrl);
  };

  async authenticate(): Promise<BankIdAuthResponse> {
    //const returnUrl = this.setNonceUrl();

    const url = `${CONTROLLER}authenticate`;

    return await this.call('GET', url);
  }

  createBankIdOpenerUrl = (autoStartToken: string): string => {
    // For documentation june 2025: It should be safer to use the universal link
    // to open BankID on mobile, but iOS can't make it work if the user isn't on
    // Safari and doesn't have Safari set as standard browser. We could check the
    // User-Agent to choose either the universal link or the URL Scheme link depending
    // on if the user is on an iPhone with Chrome instead of Safari.
    //
    // Here we use the URL Scheme link for now as it works better with getting the BankID app to open.
    //const universalLinkForMobile = `https://app.bankid.com/?autostarttoken=${autoStartToken}&redirect=null`;
    const urlSchemeLink = `bankid:///?autostarttoken=${autoStartToken}&redirect=null`;

    return urlSchemeLink;
  };

  async autostart(): Promise<BankIdAuthResponse> {
    //const returnUrl = this.setNonceUrl();

    const requestUrl = `${CONTROLLER}authenticate`;
    const res = await this.call('GET', requestUrl);

    const bankIdOpenerUrl = this.createBankIdOpenerUrl(res.AutoStartToken);
    window.location.href = bankIdOpenerUrl;

    return res;
  }

  async authostartWithSign(): Promise<BankIdAuthResponse> {
    const requestUrl = `${CONTROLLER}sign`;
    const res = await this.get(requestUrl);

    const bankIdOpenerUrl = this.createBankIdOpenerUrl(res.AutoStartToken);
    window.location.href = bankIdOpenerUrl;

    return res;
  }

  async sign(): Promise<any> {
    const URL = `${CONTROLLER}sign`;
    return await this.get(URL);
  }

  async collect(xref: string, isSign = false): Promise<BankIdCollectResponse> {
    const url = `${CONTROLLER}Collect?orderReference=${xref}&isSign=${isSign}`;
    return await this.call('GET', url);
  }

  async cancel(orderRef: string) {
    const url = `${CONTROLLER}Cancel?orderReference=${orderRef}`;
    return await this.get(url);
  }
}

export default MobiltBankIdModule;
